import React from "react";
import Measure from "react-measure";
import { MIN_GRID_HEIGHT } from "utils/constants";
import { DataGrid } from "rhombus-react";
import { QrDesigns } from "reducers/QrDesigns";
import { useDispatch } from "react-redux";

export default function Grid({ libraryId, qrCodes=[], columns= [], sort = "" }){
	function getQrRow(rowID){
		if(rowID === -1){ return; } // -1 is the header row, and doesn't need to return data
		const row = qrCodes[rowID];
		return { ...row };
	}

	const dispatch = useDispatch()
		, [sortColumn, sortDirection] = sort.split(":");

	const ROW_HEIGHT = 48;
	const dataGridProps = {
		columns,
		rowGetter:  getQrRow,
		rowsCount:  qrCodes.length,
		rowHeight:  ROW_HEIGHT,
		sortColumn,
		sortDirection,
		onGridSort: (col, dir) => dispatch(QrDesigns.setSort(col, dir)),
		enableCellAutoFocus: false,
	};
	return (
		<Measure>
			{(obj) => {
				let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;

				return (
					<div className="measure-component" ref={obj.measureRef}>
						<div>
							<DataGrid
								{...dataGridProps}
								minHeight={gridHeight}
							/>
						</div>
					</div>
				);
			}}
		</Measure>
	);
}

Grid.displayName = "Grid";
